import { render, staticRenderFns } from "./TrainingItemResourcesEditor.vue?vue&type=template&id=4fc3a693&"
import script from "./TrainingItemResourcesEditor.vue?vue&type=script&lang=js&"
export * from "./TrainingItemResourcesEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports